export default __webpack_public_path__ + "static/media/You_re Too Slow.3c5d9f61.png";